/* eslint-disable no-return-assign */
/* eslint-disable no-plusplus */
/* eslint-disable react/button-has-type */
/* eslint-disable no-nested-ternary */
/* eslint-disable import/no-extraneous-dependencies */
import React, { useEffect, useRef } from 'react';
import { useLocation, NavLink } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.js';
import './sidebar2.css';
import { Sidenav, Nav } from 'rsuite';
import 'react-datepicker/dist/react-datepicker.css';
import {
  ContentPasteSearchRounded as ContentPasteSearchRoundedIcon,
  DatasetLinkedOutlined as DatasetLinkedOutlinedIcon,
  InventoryOutlined as InventoryOutlinedIcon,
  RepeatOutlined as RepeatOutlinedIcon,
  AddchartRounded as AddchartRoundedIcon,
  CheckCircleOutlined as CheckCircleOutlinedIcon,
  WorkspacePremiumOutlined as WorkspacePremiumOutlinedIcon,
  // LogoutOutlined as LogoutOutlinedIcon,
  SourceOutlined as SourceOutlinedIcon,
  Dashboard as DashboardIcon,
  SummarizeOutlined as SummarizeOutlinedIcon,
  DisplaySettings as DisplaySettingsIcon,
  PublishedWithChangesRounded as PublishedWithChangesRoundedIcon,
  BackupTable as BackupTableIcon,
  FolderOff as FolderOffIcon,
  Inventory as InventoryIcon,
  ShoppingCartOutlined as ShoppingCartOutlinedIcon,
  ShoppingCartCheckout as ShoppingCartCheckoutIcon,
  Widgets as WidgetsIcon,
  MenuBook as MenuBookIcon,
} from '@mui/icons-material';
import DetailsIcon from '@mui/icons-material/Details';
import ManageHistoryIcon from '@mui/icons-material/ManageHistory';
// import Swal from 'sweetalert2';
import Typography from '@mui/material/Typography';
import AssignmentLateOutlinedIcon from '@mui/icons-material/AssignmentLateOutlined';
import AssignmentReturnOutlinedIcon from '@mui/icons-material/AssignmentReturnOutlined';
import AddToQueueIcon from '@mui/icons-material/AddToQueue';
import Inventory2OutlinedIcon from '@mui/icons-material/Inventory2Outlined';
import GraphicEqIcon from '@mui/icons-material/GraphicEq';
import AutoGraphIcon from '@mui/icons-material/AutoGraph';
import SsidChartIcon from '@mui/icons-material/SsidChart';
import StackedLineChartIcon from '@mui/icons-material/StackedLineChart';
import DonutSmallIcon from '@mui/icons-material/DonutSmall';
import RecentActorsIcon from '@mui/icons-material/RecentActors';
import PlaylistRemoveIcon from '@mui/icons-material/PlaylistRemove';
import { useStateContext } from '../contexts/ContextProvider';

const Sidebar = () => {
  const location = useLocation();
  const tabRefs = useRef({});
  // useeffect only for scroll for bottom setting
  useEffect(() => {
    const currentPath = decodeURIComponent(location.pathname.replace('/', ''));
    const element = tabRefs.current[currentPath];
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth',
        block: 'center',
      });
    }
  }, [location.pathname]);

  const { currentColor, activeMenu, setActiveMenu, screenSize } = useStateContext();
  // const navigate = useNavigate();
  const InventorytabList = JSON.parse(localStorage.getItem('loginID'))?.inventoryDetail;
  const ActivitytabList = JSON.parse(localStorage.getItem('loginID'))?.activityDetail;
  const AnalyticsList = JSON.parse(localStorage.getItem('loginID'))?.analyticsDetail;
  const tabs = [];
  const activeTab = [];
  const analytic = [];
  for (let i = 0; i < AnalyticsList?.length; i++) {
    analytic.push(AnalyticsList[i]?.PageName);
  }
  for (let i = 0; i < ActivitytabList?.length; i++) {
    activeTab.push(ActivitytabList[i]?.PageName);
  }
  for (let i = 0; i < InventorytabList?.length; i++) {
    tabs.push(InventorytabList[i]?.PageName);
  }
  const handleCloseSideBar = () => {
    if (activeMenu !== undefined && screenSize <= 900) {
      setActiveMenu(false);
    }
  };

  const activeLink = 'flex items-center gap-3 pl-2 pt-2 pb-2 rounded-lg  text-white  text-md ';
  const normalLink = 'flex items-center gap-3 pl-2 pt-2 pb-2 rounded-lg text-md text-gray-700 dark:text-gray-200 dark:hover:text-black hover:bg-light-gray ';
  return (
    <div
      className="h-screen md:overflow-hidden overflow-auto md:hover:overflow-auto pb-1"
      style={{ backgroundColor: '#EEEEEE', zIndex: '9999000' }}
    >
      {activeMenu && (
        <div style={{ width: '100%' }}>
          <Sidenav
            className="accordion"
            id="accordionExample"
            defaultOpenKeys={['1']}
            // appearance="" //FOR HOVER EFFECT FOR SIDEBAR IN ALL PAGES
            appearance="subtle"
            style={{ backgroundColor: 'white', color: 'black' }}
          >
            <Sidenav.Body>
              <Nav activeKey="1">
                <div>
                  {(ActivitytabList?.length > 0) ? (
                    <Nav.Item
                      panel
                      eventKey="4-0"
                      style={{
                        padding: '15px 0px',
                        backgroundColor: '#ECF2FF',
                        borderRadius: '10px',
                        marginBottom: '10px',
                      }}
                    >
                      <Typography variant="h5" component="h2">
                        <WidgetsIcon /> Activity
                      </Typography>
                    </Nav.Item>
                  ) : null}

                  <div id="tabs_list">
                    {activeTab.map((list) => (
                      <li
                        key={list}
                        style={{ marginTop: '-18px', marginLeft: '30px', padding: '0px' }}
                        ref={(el) => (tabRefs.current[list] = el)}
                      >
                        <Nav.Item eventKey={`1-${list}`} style={{ textDecoration: 'none', height: '60px', padding: '0px' }}>
                          <NavLink
                            to={`/${list}`}
                            key={list}
                            onClick={handleCloseSideBar}
                            style={({ isActive }) => ({
                              backgroundColor: isActive ? currentColor : '',
                              textDecoration: 'none',
                              // marginRight: '-20px',
                              fontSize: '16px',
                            })}
                            className={({ isActive }) => (isActive ? activeLink : normalLink)}
                          >
                            {list === 'SimpliCertified Production' ? (
                              <WorkspacePremiumOutlinedIcon />
                            ) : list === 'Inbound RMA' ? (
                              <span id="symbol">
                                <BackupTableIcon />
                              </span>
                            ) : list === 'RA Lookup' ? (
                              <span id="symbol">
                                <InventoryOutlinedIcon />
                              </span>
                            ) : list === 'Daily Product Returns Activity' ? (
                              <span id="symbol">
                                <RepeatOutlinedIcon />
                              </span>
                            ) : list === 'Outbound Shipment History' ? (
                              <span id="symbol">
                                <PublishedWithChangesRoundedIcon />
                              </span>
                            ) : list === 'Failure Codes' ? (
                              <span id="symbol">
                                <FolderOffIcon />
                              </span>
                            ) : list === 'QC Details' ? (
                              <span id="symbol">
                                <DetailsIcon />
                              </span>
                            ) : list === 'Ebay Shipping History' ? (
                              <span id="symbol">
                                <ShoppingCartOutlinedIcon />
                              </span>
                            ) : list === 'Core Putaway' ? (
                              <span id="symbol">
                                <ShoppingCartCheckoutIcon />
                              </span>
                            ) : list === 'Product Return Serial' ? (
                              <span id="symbol">
                                <ManageHistoryIcon />
                              </span>
                            ) : list === 'CMOB1 QC' ? (
                              <span id="symbol">
                                <SourceOutlinedIcon />
                              </span>
                            ) : list === 'RA Return Reasons' ? (
                              <span id="symbol">
                                <AssignmentLateOutlinedIcon />
                              </span>
                            ) : list === 'Returns SLA' ? (
                              <span id="symbol">
                                <AssignmentReturnOutlinedIcon />
                              </span>
                            ) : list === 'Backlog RMA' ? (
                              <span id="symbol">
                                <AddToQueueIcon />
                              </span>
                            ) : list === 'Blanket RMA' ? (
                              <span id="symbol">
                                <Inventory2OutlinedIcon />
                              </span>
                            ) : list === 'Transfer Intake' ? (
                              <span id="symbol">
                                <DatasetLinkedOutlinedIcon />
                              </span>
                            ) : list === 'UnAuthorized List' ? (
                              <span id="symbol">
                                <PlaylistRemoveIcon />
                              </span>
                            ) : null}
                            {list}
                          </NavLink>
                        </Nav.Item>
                      </li>
                    ))}
                  </div>
                </div>
                <div>
                  {(tabs?.length > 0) ? (
                    <Nav.Item
                      panel
                      eventKey="5-0"
                      style={{
                        padding: '15px 0px',
                        backgroundColor: '#ECF2FF',
                        borderRadius: '10px',
                        marginBottom: '10px',
                      }}
                    >
                      <Typography variant="h5" component="h2">
                        <MenuBookIcon /> Inventory
                      </Typography>
                    </Nav.Item>
                  ) : null}
                  <div id="tabs_list">
                    {tabs.map((list) => (
                      <li
                        key={list}
                        style={{ marginTop: '-18px', marginLeft: '30px', padding: '0px' }}
                        ref={(el) => (tabRefs.current[list] = el)}
                      >
                        {' '}
                        <Nav.Item eventKey={`1-${list}`} style={{ textDecoration: 'none', height: '60px', padding: '0px' }}>
                          <NavLink
                            to={`/${list}`}
                            key={list}
                            onClick={handleCloseSideBar}
                            style={({ isActive }) => ({
                              backgroundColor: isActive ? currentColor : '',
                              textDecoration: 'none',
                              fontSize: '16px',
                            // marginRight: '-20px',
                            })}
                            className={({ isActive }) => (isActive ? activeLink : normalLink)}
                          >
                            {list === 'FG Inventory' ? (
                              <CheckCircleOutlinedIcon />
                            ) : list === 'ProductionActivity' ? (
                              <span id="symbol">
                                <RepeatOutlinedIcon />
                              </span>
                            ) : list === 'Materials Inventory' ? (
                              <span id="symbol">
                                <ContentPasteSearchRoundedIcon />
                              </span>
                            ) : list === 'Core Inventory' ? (
                              <span id="symbol">
                                <AddchartRoundedIcon />
                              </span>
                            ) : list === 'Inventory Adjustments' ? (
                              <span id="symbol">
                                <InventoryIcon />
                              </span>
                            ) : list === 'ProductReturnsSummary' ? (
                              <span id="symbol">
                                <InventoryOutlinedIcon />
                              </span>
                            ) : list === 'InboundRARequest' ? (
                              <span id="symbol">
                                {/* <DatasetLinkedOutlinedIcon /> */}
                              </span>
                            ) : list === 'Grade A Product' ? (
                              <span id="symbol">
                                {/* <SourceOutlinedIcon /> */}
                              </span>
                            ) : null}
                            {/* {' '} */}
                            {list}
                          </NavLink>
                        </Nav.Item>
                      </li>
                    ))}
                  </div>
                  <div>
                    {(AnalyticsList?.length > 0) ? (
                      <Nav.Item
                        panel
                        eventKey="4-0"
                        style={{
                          padding: '15px 0px',
                          backgroundColor: '#ECF2FF',
                          borderRadius: '10px',
                          marginBottom: '10px',
                        }}
                      >
                        <Typography variant="h5" component="h2">
                          <DonutSmallIcon /> Analytics
                        </Typography>
                      </Nav.Item>
                    ) : null}
                    <div id="tabs_list">
                      {analytic.map((list) => (
                        <li
                          key={list}
                          style={{ marginTop: '-18px', marginLeft: '30px', padding: '0px' }}
                          ref={(el) => (tabRefs.current[list] = el)}
                        >
                          {' '}
                          <Nav.Item eventKey={`1-${list}`} style={{ textDecoration: 'none', height: '60px', padding: '0px' }}>
                            <NavLink
                              to={`/${list}`}
                              key={list}
                              onClick={handleCloseSideBar}
                              style={({ isActive }) => ({
                                backgroundColor: isActive ? currentColor : '',
                                textDecoration: 'none',
                                fontSize: '16px',
                                // marginRight: '-20px',
                              })}
                              className={({ isActive }) => (isActive ? activeLink : normalLink)}
                            >
                              {list === 'Receiving Trends' ? (
                                <AutoGraphIcon />
                              ) : list === 'Receiving Trends By Vendor' ? (
                                <span id="symbol">
                                  <GraphicEqIcon />
                                </span>
                              ) : list === 'Certified Trends' ? (
                                <span id="symbol">
                                  <SsidChartIcon />
                                </span>
                              ) : list === 'Ebay Trends' ? (
                                <span id="symbol">
                                  <StackedLineChartIcon />
                                </span>
                              ) : null}
                              {list}
                            </NavLink>
                          </Nav.Item>
                        </li>
                      ))}
                    </div>
                  </div>
                  {JSON.parse(localStorage.getItem('loginID')) !== null || undefined ? (
                    (JSON.parse(localStorage.getItem('loginID')).dashboardDetail.length !== 0 ? (
                      <div className="tabs_list1">
                        <Nav.Item eventKey="6-3" style={{ textDecoration: 'none', backgroundColor: '#ECF2FF', borderRadius: '10px' }}>
                          <NavLink
                            ref={(el) => (tabRefs.current['Dashboard View'] = el)}
                            to="/Dashboard View"
                            key="6-4"
                            onClick={handleCloseSideBar}
                            style={({ isActive }) => ({
                              backgroundColor: isActive ? currentColor : '',
                              textDecoration: 'none',
                              marginRight: '-20px',
                            })}
                            className={({ isActive }) => (isActive ? activeLink : normalLink)}
                          ><DashboardIcon />
                            <Typography variant="h6" component="h6">
                              { JSON.parse(localStorage.getItem('loginID')).dashboardDetail[0]?.PageName}
                            </Typography>
                          </NavLink>
                        </Nav.Item>
                      </div>
                    ) : null)
                  ) : null }

                  {JSON.parse(localStorage.getItem('loginID')) !== null || undefined ? (
                    (JSON.parse(localStorage.getItem('loginID')).summaryDetail.length !== 0) ? (
                      <div className="tabs_list1">
                        <Nav.Item eventKey="6-4" style={{ textDecoration: 'none', backgroundColor: '#ECF2FF', borderRadius: '10px' }}>
                          <NavLink
                            ref={(el) => (tabRefs.current.Summaries = el)}
                            to="/Summaries"
                            key="6-5"
                            onClick={handleCloseSideBar}
                            style={({ isActive }) => ({
                              backgroundColor: isActive ? currentColor : '',
                              textDecoration: 'none',
                              marginRight: '-20px',
                            })}
                            className={({ isActive }) => (isActive ? activeLink : normalLink)}
                          ><SummarizeOutlinedIcon />
                            <Typography variant="h6" component="h6">
                              { JSON.parse(localStorage.getItem('loginID')).summaryDetail[0]?.PageName}
                            </Typography>
                          </NavLink>
                        </Nav.Item>
                      </div>
                    ) : null
                  ) : null }
                  {JSON.parse(localStorage.getItem('loginID')) !== null || undefined ? (
                    (JSON.parse(localStorage.getItem('loginID')).skuDetail.length !== 0) ? (
                      <div className="tabs_list1">
                        <Nav.Item eventKey="6-5" style={{ textDecoration: 'none', backgroundColor: '#ECF2FF', borderRadius: '10px' }}>
                          <NavLink
                            ref={(el) => (tabRefs.current['Item Master'] = el)}
                            to="/Item Master"
                            key="6-6"
                            onClick={handleCloseSideBar}
                            style={({ isActive }) => ({
                              backgroundColor: isActive ? currentColor : '',
                              textDecoration: 'none',
                              marginRight: '-20px',
                            })}
                            className={({ isActive }) => (isActive ? activeLink : normalLink)}
                          ><DisplaySettingsIcon />
                            <Typography variant="h6" component="h6">
                              { JSON.parse(localStorage.getItem('loginID')).skuDetail[0]?.PageName}
                            </Typography>
                          </NavLink>
                        </Nav.Item>
                      </div>
                    ) : null
                  ) : null }

                  {JSON.parse(localStorage.getItem('loginID')) !== null || undefined ? (
                    (JSON.parse(localStorage.getItem('loginID')).skuDetail.length === 5) ? (
                      <div className="tabs_list1">
                        <Nav.Item eventKey="6-5" style={{ textDecoration: 'none', backgroundColor: '#ECF2FF', borderRadius: '10px' }}>
                          <NavLink
                            ref={(el) => (tabRefs.current['Retail Item Master'] = el)}
                            to="/Retail Item Master"
                            key="6-7"
                            onClick={handleCloseSideBar}
                            style={({ isActive }) => ({
                              backgroundColor: isActive ? currentColor : '',
                              textDecoration: 'none',
                              marginRight: '-20px',
                            })}
                            className={({ isActive }) => (isActive ? activeLink : normalLink)}
                          ><RecentActorsIcon />
                            <Typography variant="h6" component="h6">
                              { JSON.parse(localStorage.getItem('loginID')).skuDetail[4]?.PageName}
                            </Typography>
                          </NavLink>
                        </Nav.Item>
                      </div>
                    ) : null
                  ) : null }
                </div>
              </Nav>
            </Sidenav.Body>
          </Sidenav>
        </div>
      )}
    </div>
  );
};

export default Sidebar;
